import { IResponseData } from '@/core/interfaces/common'
import { WalletWithdrawalModel } from '@/modules/Profile/Wallets/models/WalletsModel'
import { AxiosResponse } from 'axios'

import { http } from '@/utils/http'

import {
  IChatsWalletRequest,
  IChatsWalletResponse,
  Wallet,
  WalletChartRequest,
  WalletChartResponse,
  WalletOperationRequest,
  WalletOperationResponse,
  WalletPage,
  WalletReceive,
  WalletWithdrawalResponse,
  WalletsResponse,
  WithdrawalResponse,
} from './WalletInterface'

class WalletService {
  async getWallets(): Promise<Wallet[]> {
    const res = await http.get<WalletsResponse>(`/profile/wallets2`)
    return res.data.wallets
  }
  async getWallet(code: string): Promise<WalletPage> {
    const res = await http.get<WalletPage>(`/profile/withdrawal/${code}`)
    return res.data
  }

  async getWalletChart(data: WalletChartRequest): Promise<WalletChartResponse> {
    const res = await http.get<WalletChartResponse>(
      `/profile/wallets/${data.code}/chars/${data.filter}`,
    )
    return res.data
  }

  async getWalletReceive(code: string): Promise<WalletReceive> {
    const res = await http.get<WalletReceive>(
      `/profile/wallets/${code}/receive`,
    )
    return res.data
  }

  async getWalletWithdrawal(code: string): Promise<WalletWithdrawalResponse> {
    const res = await http.get<WalletWithdrawalResponse>(
      `/profile/withdrawal/${code}`,
    )
    return res.data
  }

  async getWalletOperations(
    data: WalletOperationRequest,
  ): Promise<IResponseData<WalletOperationResponse[]>> {
    const { code, page } = data
    const res = await http.get<IResponseData<WalletOperationResponse[]>>(
      `/profile/wallets/${code}/operations?page=${page}`,
    )
    return res.data
  }

  async withdrawal(data: WalletWithdrawalModel): Promise<WithdrawalResponse> {
    const { code, ...rest } = data
    const res = await http.post<
      Omit<WalletWithdrawalModel, 'code'>,
      AxiosResponse<WithdrawalResponse>
    >(`/profile/wallets/${code}/withdrawal`, rest)
    return res.data
  }

  async getChatsWallet(
    data: IChatsWalletRequest,
  ): Promise<IChatsWalletResponse> {
    const res = await http.get<IChatsWalletResponse>(
      `/profile/wallets/${data.code}/chars/${data.params}`,
    )
    return res.data
  }
}

export default new WalletService()
